import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

export type SbEmptyStateProps = {
  iconClass: string;
  title: string;
  description: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
};

export default function SbEmptyState({
  iconClass,
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: SbEmptyStateProps) {
  const action =
    actionLabel && actionTo ? (
      <Link to={actionTo} className="btn btn-primary">
        {actionLabel}
      </Link>
    ) : actionLabel && onAction ? (
      <Button type="button" className="btn btn-primary" onClick={onAction}>
        {actionLabel}
      </Button>
    ) : null;

  return (
    <div className="sb-panel sb-empty-state text-center">
      <div className="sb-empty-state__icon-wrap" aria-hidden>
        <i className={`${iconClass} sb-empty-state__icon`} />
      </div>
      <h2 className="sb-empty-state__title">{title}</h2>
      <p className="sb-empty-state__description">{description}</p>
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
